var map = {
	"./site-logo-desktop-footer.svg": 86997,
	"./site-logo-desktop.svg": 45507,
	"./site-logo-drawer-mobile.svg": 34189,
	"./site-logo-drawer.svg": 51150,
	"./site-logo-mobile-drawer.svg": 80479,
	"./site-logo-mobile.svg": 28695,
	"./site-logo-sm.svg": 47373,
	"./site-logo-tv.svg": 60315,
	"./site-logo-wrapper-mobile-scrolled.svg": 1546,
	"./site-logo-wrapper-mobile.svg": 52325,
	"./site-logo-wrapper-scrolled.svg": 26391,
	"./site-logo-wrapper.svg": 66694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2127;